export default __webpack_public_path__ + "static/media/icons-system-chevron-right.26fb9b69.svg";